"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMiniProfile = void 0;
const profile_avatar_1 = require("@shared-modules/components/profile-avatar");
const object_1 = require("@utils/object");
const React = __importStar(require("react"));
const unknown_png_1 = __importDefault(require("@assets/unknown.png"));
require("./styles.scss");
const UserMiniProfile = (props) => {
    const { displayName, address, title, avatar } = props;
    const name = displayName || (0, object_1.formatAddress)(address);
    return (React.createElement("div", { className: "c-user-mini-profile" },
        React.createElement(profile_avatar_1.ProfileAvatar, { src: avatar || unknown_png_1.default }),
        React.createElement("div", { className: "c-user-mini-profile__user-info" },
            title && React.createElement("div", { className: "c-user-mini-profile__user-role" }, title),
            React.createElement("div", { className: "c-user-mini-profile__user-name" },
                React.createElement("a", { target: "_blank", href: `/profile/${address}`, title: address, className: "c-user-mini-profile__user-name g-link" }, name)))));
};
exports.UserMiniProfile = UserMiniProfile;
